import React from 'react'
import cn from 'classnames'


let Input = (props) => {
    let {input, autoComplete = "on", ...customProps} = props
    let {type, id} = customProps
    let idProp = id ? {id} : {}

    return (
        <input
            type = {type}
            className = {cn({
                "form-control" : type !== 'checkbox',
            })}
            autoComplete = {autoComplete}
            {...idProp}
            {...input}
        />
    )
}

export default Input


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/common/Form/Input.js